import BaseService from '../../base/base_service';
import _ from '../../utils/underscore';
import IHistoryService, { IDailyDealCampaign } from './history_service_interface';

export interface IHistoryServiceParams {
    uri: string;
    gameSessionUri: string;
    recentlyPlayedUri: string;
    aiRecommendedGameListUri: string;
    popupCampaignsUrl: string;
}


export default class HistoryService extends BaseService implements IHistoryService {
    static CLASS = 'HistoryService';

    private _params: IHistoryServiceParams;


    init(params: IHistoryServiceParams) {
        super.init(params);
        this._params = params;
    }


    getRecentlyPlayed(): Promise<{gameTypes: number[]}> {
        return this.serviceFactory.http2Service().post(this._params.recentlyPlayedUri);
    }

    /**
     * Gets the AI Recommended Game List from the server / platform
     * @returns {Promise|Object{RecommendedGameList : Object}
     */
    getAIRecommendedGameList(): Promise<{[gameType: number]: number}> {
        return new Promise((resolve) => {
            this.serviceFactory.http2Service().post(this._params.aiRecommendedGameListUri).then((data: any) => {
                try {
                    if (typeof data !== 'object')
                        resolve({});

                    resolve(data.RecommendedGameList);
                } catch (e) {
                    this.logger.error('Failed to parse get AI recommended list response, error:' + e);
                    resolve({});
                }
            });
        });
    }

    public getDailyDealCampaigns(): Promise<IDailyDealCampaign[]> {
        if (_.isEmpty(this._params.popupCampaignsUrl)) {
            return Promise.resolve([]);
        }
        return this.serviceFactory.http2Service().post(this._params.popupCampaignsUrl)
            .then((data: any) => (data && data.MarketingCampaigns) || [])
            .catch(() => []);
    }
}
